import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import MenuItem from "@mui/material/MenuItem";

import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
import Select from "@mui/material/Select";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { Update_User } from "../../Redux/actions";
import DropZone from "../../Components/Applications/DropzoneForSignatures";
import { useTranslation } from "react-i18next";

const ChangeNameForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);

  const [isSubmitable, setIsSubmitable] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [mom, setMom] = useState("");
  const [chairmanSignature, setChairmanSignature] = useState("");
  const [secretarySignature, setSecretarySignature] = useState("");

  const { customerId, bookingId } = useParams();

  const user = useSelector((state) => state?.UserReducer?.user);

  const [customerDetails, setCustomerDetails] = useState({});
  const [isPublished, setIsPublished] = useState(false);
  const [assocName, setAssocNameLabel] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const [previewOpenModel, setPreviewOpenModel] = useState(false);
  const [isReportsent, setIsReportSent] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [reportId, setReportId] = useState("");

  const [isAddDeviceModelOpen, setIsAddDeviceModelOpen] = useState(false);
  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);
  const [openCreateBookingModel, setOpenCreateBookingModel] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!previewOpenModel) setIsReportSent(false);
  }, [previewOpenModel]);

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);

  // -------------  Initial Data -------------
  // const fetchFunction = async () =>
  //   await axios.get(
  //     `${Config.nodeApiUrl}/getSenderIdContactGroups/sms`,
  //     Config.AxiosConfig
  //   );

  // const {
  //   data,
  //   error,
  //   isLoading: InitialLoading,
  // } = useQuery(`getSenderIdContactGroups`, fetchFunction);

  // -------------   Run Campaign  -------------
  const runCampaignFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/changename`, values, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: runCampaignLoading, mutate: runCampaignMutate } =
    useMutation(runCampaignFunction, {
      onSuccess: onSuccess,
      onError: onError,
    });

  const InitialValue = {
    assocName: "",
    newName: "",
    reason: "",
    dated: "",
  };

  const SubmitHandler = (values) => {
    if (isSubmitable) {
      if (!values.assocId) {
        return toast.error("Please enter a Current Association name");
      } else if (!values.newName) {
        return toast.error("Please enter a New Association name");
      } else if (!values.reason) {
        return toast.error("Please enter a reason");
      } else if (!values.dated) {
        return toast.error("Please enter the Date");
      } else if (!mom) {
        return toast.error("Please upload minutes of meeting");
      } else if (!chairmanSignature) {
        return toast.error("Please upload Chairman National Id");
      } else if (!secretarySignature) {
        return toast.error("Please upload Secretary National Id");
      }

      const body = new FormData();
      body.append("customerId", user.id);
      body.append("assocId", values.assocId);
      body.append("assocName", assocName);
      // body.append("name", values.name);
      body.append("newName", values.newName);
      body.append("reason", values.reason);
      body.append("dated", values.dated);
      body.append("mom", mom);
      body.append("chairmanSign", chairmanSignature);
      body.append("secretarySign", secretarySignature);
      runCampaignMutate(body);
    } else {
      setIsSubmitable(true);
    }
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t("APPLICATION_ASSOCIATION")}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>{t("Application_Association")}</BoxSubTitle>

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
            enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                    <>
                      <InputGroup>
                        <Label htmlFor="name">{t("a_name")}</Label>
                        <FieldWrapper $select={true}>
                          <Field
                            required
                            name="name"
                            id="name"
                            autoComplete="off"
                          >
                            {(props) => (
                              <Select
                                {...props.field}
                                className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                onChange={(e) => {
                                  const selectedItem = user.associations.find(
                                    (item) => item.id == e.target.value
                                  );
                                  setAssocNameLabel(selectedItem.assocName);
                                  // SetDynamicAssociation(e.target.value);
                                  props.form.setFieldValue(
                                    "assocId",
                                    e.target.value
                                  );
                                }}
                              >
                                {user.associations &&
                                  user.associations.map((item) => (
                                    <MenuItem value={item.id}>
                                      {item.assocName}
                                    </MenuItem>
                                  ))}
                              </Select>
                            )}
                          </Field>
                        </FieldWrapper>
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="newName">{t("New_Association")}</Label>
                        <FieldWrapper>
                          <Field
                            name="newName"
                            id="newName"
                            autoComplete="off"
                          />
                        </FieldWrapper>
                      </InputGroup>

                      {/* <InputGroup>
                          <Label htmlFor="postal">
                            Portal Address Of Association
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="postal"
                              id="postal"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                      <InputGroup>
                        <Label htmlFor="reason">{t("Change_desire")}</Label>
                        <FieldWrapper>
                          <Field
                            name="reason"
                            as="textarea"
                            rows="6"
                            id="reason"
                            placeholder={t("Reason")}
                            autoComplete="off"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="dated">{t("Dated")}</Label>
                        <FieldWrapper>
                          <Field
                            name="dated"
                            id="dated"
                            autoComplete="off"
                            type="date"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="chairmanSignature">
                          Please upload chairman national id
                        </Label>
                        <DropZone setUploadFile={setChairmanSignature} />
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="secretarySignature">
                          Please upload secretary national id
                        </Label>
                        <DropZone setUploadFile={setSecretarySignature} />
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="mom">{t("mom")}</Label>
                        <DropZone setUploadFile={setMom} />
                      </InputGroup>
                    </>
                  </FormContainer>
                  <div className="mt-14">
                    <SubmitBtn type="submit" disabled={runCampaignLoading}>
                      {runCampaignLoading && (
                        <Loading
                          color="white"
                          width={20}
                          height={20}
                          noPadding={true}
                        />
                      )}
                      {!runCampaignLoading && t("Send")}
                    </SubmitBtn>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default ChangeNameForm;
